import React, { useState, useEffect } from "react";
import BuildingDrawer from "./components/BuildingDrawer";
import BuildingBookTopRightTools from "./components/BuildingBookTopRightTools";
import { functions } from "../../constants/common-functions";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCity } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function BuildingNavigator({onOpenForge}) {

  const urn = "dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLkNMcVU3MWsxU0tHN3V2SE5wNXZGcnc_dmVyc2lvbj0x";
	
  const history = useHistory();
  
  useEffect(() => {
	
	 functions.redirectDemoUser(history);
  }, []);
  
  
  
  
  const buildings = [
    {
      id: 1,
      name: "Palestra House",
      location: "London",
      address: "197 Southwark Bridge Rd, London SE1",
      areaSqFt: "113,988",
      floors: 8,
      capacity: 1200,
      yearBuilt: 2006,
      description: "A landmark commercial building in Southwark, supporting mixed-use enterprise and public services.",
      image: "/roombooking/building1.jpg",
      x: "48%",
      y: "46%"
    },
    {
      id: 2,
      name: "North Wing",
      location: "Leeds",
      address: "Innovation Park, Leeds",
      areaSqFt: "72,400",
      floors: 5,
      capacity: 650,
      yearBuilt: 2012,
      description: "A modern innovation hub supporting advanced manufacturing and R&D.",
      image: "/roombooking/building2.jpg",
      x: "62%",
      y: "52%"
    },
    {
      id: 3,
      name: "South Block",
      location: "Manchester",
      address: "Spinningfields, Manchester",
      areaSqFt: "64,200",
      floors: 6,
      capacity: 840,
      yearBuilt: 2014,
      description: "A high-performance office building designed for collaboration and flexibility.",
      image: "/roombooking/building3.jpg",
      x: "35%",
      y: "58%"
    },
    {
      id: 4,
      name: "East Tower",
      location: "Birmingham",
      address: "Colmore Row, Birmingham",
      areaSqFt: "89,500",
      floors: 10,
      capacity: 1100,
      yearBuilt: 2010,
      description: "A prime city-centre tower supporting professional services and finance.",
      image: "/roombooking/building4.jpg",
      x: "55%",
      y: "40%"
    },
    {
      id: 5,
      name: "West Campus",
      location: "Bristol",
      address: "Harbourside, Bristol",
      areaSqFt: "52,300",
      floors: 4,
      capacity: 520,
      yearBuilt: 2016,
      description: "A sustainable campus-style development overlooking Bristol’s historic harbour.",
      image: "/roombooking/building5.jpg",
      x: "42%",
      y: "34%"
    }
  ];

  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);

  const mainContainer = {
    display: "flex",
    width: "100%",
    height: "100vh",
    backgroundColor: "#ffffff",
    overflow: "hidden",
    position: "relative"
  };

  const aerialWrapper = {
    width: "100%",
    height: "100%",
    position: "relative"
  };

  const aerialPhotoStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    filter: "brightness(0.85)"
  };

  // New marker style: bigger, yellow, icon, proper shadow
  const markerStyle = {
    position: "absolute",
    width: "40px",
    height: "40px",
    background: "linear-gradient(180deg, #ffd33d 0%, #ffb703 100%)",
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow:
      "0 10px 18px rgba(0,0,0,0.35), 0 0 0 8px rgba(255,183,3,0.22)",
    cursor: "pointer",
    transition: "transform 0.18s ease, box-shadow 0.18s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 25
  };

  const popupStyle = {
    position: "absolute",
    background: "linear-gradient(135deg, #1f2b44 0%, #121821 100%)",
    color: "white",
    padding: "0px",
    borderRadius: "14px",
    minWidth: "320px",
    maxWidth: "320px",
    boxShadow: "0 18px 40px rgba(0,0,0,0.45)",
    fontSize: "13px",
    zIndex: 30,
    border: "1px solid rgba(255,255,255,0.08)"
  };

  const popupButton = {
    marginTop: "12px",
    width: "100%",
    border: "none",
    borderRadius: "10px",
    padding: "10px 12px",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: "13px",
    color: "#1b1f27",
    background: "linear-gradient(180deg, #ffd33d 0%, #ffb703 100%)",
    boxShadow: "0 10px 18px rgba(0,0,0,0.30)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease"
  };
  
  const pulseStyle = {
    animation: "markerPulse 2.2s ease-in-out infinite"
  };

  return (
    <>
	<style>
	{`
	@keyframes markerPulse {
	  0%   { box-shadow: 0 10px 18px rgba(0,0,0,0.35), 0 0 0 8px rgba(255,183,3,0.18); }
	  50%  { box-shadow: 0 14px 22px rgba(0,0,0,0.40), 0 0 0 12px rgba(255,183,3,0.26); }
	  100% { box-shadow: 0 10px 18px rgba(0,0,0,0.35), 0 0 0 8px rgba(255,183,3,0.18); }
	}
	`}
	</style>
	

      <div style={mainContainer}>

        {/* Diamond logo swoosh - top left */}
        <div style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          width: "270px",
          height: "120px",
          background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
          boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
          borderTopRightRadius: "140px 120px",
          borderBottomRightRadius: "80px 100px",
          //borderTopLeftRadius: "24px",
          //borderBottomLeftRadius: "24px",
          zIndex: 50,
          display: "flex",
          alignItems: "center",
          paddingLeft: "18px"
        }}>
          <img
            src="/roombooking/logo.png"
            alt="Diamond"
            style={{
              width: "240px",
              objectFit: "contain"
            }}
          />
        </div>

        {/* Aerial canvas */}
        <div style={aerialWrapper}>
          <img src="/roombooking/campus.jpg" style={aerialPhotoStyle} alt="Campus" />

          {/* Building markers */}
          {buildings.map((b) => {

            const isSelected = selectedBuilding && selectedBuilding.id === b.id;
            const isHovered = hoveredId === b.id;

            let markerTransform = "translate(-50%, -50%) scale(1)";
            if (isHovered) {
              markerTransform = "translate(-50%, -50%) scale(1.08)";
            }
            if (isSelected) {
              markerTransform = "translate(-50%, -50%) scale(1.18)";
            }

            return (
              <div
                key={b.id}
                style={{
					...markerStyle,
					  ...( !isSelected ? pulseStyle : {} ),
                  left: b.x,
                  top: b.y,
                  transform: markerTransform,
                  boxShadow: isHovered || isSelected
                    ? "0 14px 24px rgba(0,0,0,0.40), 0 0 0 10px rgba(255,183,3,0.26)"
                    : markerStyle.boxShadow,
					opacity: selectedBuilding && !isSelected ? 0.45 : 1,
					filter: selectedBuilding && !isSelected ? "grayscale(40%)" : "none",

                }}
                onMouseEnter={() => setHoveredId(b.id)}
                onMouseLeave={() => setHoveredId(null)}
                onClick={() => setSelectedBuilding(b)}
                title={b.name}
              >
                <FontAwesomeIcon
                  icon={faCity}
                  style={{
                    color: "#1b1f27",
                    fontSize: "16px",
                    filter: "drop-shadow(0 2px 2px rgba(255,255,255,0.35))"
                  }}
                />
              </div>
            );
          })}

          {/* Popup */}
          {selectedBuilding && !drawerOpen && (
			<div
			   style={{
			     ...popupStyle,
			     left: selectedBuilding.x,
			     top: selectedBuilding.y,
			     transform: "translate(-50%, -115%)",
			   }}
			 >
			 <div
			   onClick={() => setSelectedBuilding(null)}
			   style={{
			     position: "absolute",
			     top: "10px",
			     right: "10px",
			     width: "28px",
			     height: "28px",
			     borderRadius: "50%",
			     background: "rgba(255,255,255,0.08)",
			     display: "flex",
			     alignItems: "center",
			     justifyContent: "center",
			     cursor: "pointer",
			     transition: "background 0.15s ease, transform 0.15s ease",
			     zIndex: 5
			   }}
			   onMouseEnter={(e) => {
			     e.currentTarget.style.background = "rgba(255,255,255,0.16)";
			     e.currentTarget.style.transform = "scale(1.08)";
			   }}
			   onMouseLeave={(e) => {
			     e.currentTarget.style.background = "rgba(255,255,255,0.08)";
			     e.currentTarget.style.transform = "scale(1)";
			   }}
			 >
			   <FontAwesomeIcon
			     icon={faXmark}
			     style={{
			       color: "#ffffff",
			       fontSize: "14px",
			       opacity: 0.85
			     }}
			   />
			 </div>

			 <div
			   style={{
			     position: "relative",
			     width: "100%",
			     height: "160px",
			     overflow: "hidden"
			   }}
			 >
			   <img
			     src={selectedBuilding.image}
			     alt={selectedBuilding.name}
			     style={{
			       width: "100%",
			       height: "100%",
			       objectFit: "cover",
				   borderTopLeftRadius:'14px',
				   borderTopRightRadius:'14px'
			     }}
			   />

			   {/* Dark gradient overlay for text contrast */}
			   <div
			     style={{
			       position: "absolute",
			       bottom: 0,
			       left: 0,
			       right: 0,
			       height: "60%",
			       background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.55) 100%)"
			     }}
			   />

			   {/* Title over image */}
			   <div
			     style={{
			       position: "absolute",
			       bottom: "10px",
			       left: "14px",
			       right: "14px"
			     }}
			   >
			     <div style={{ fontSize: "16px", fontWeight: 700 }}>
			       {selectedBuilding.name}
			     </div>
			     <div style={{ fontSize: "13px", opacity: 0.85 }}>
			       {selectedBuilding.location}
			     </div>
			   </div>
			 </div>

			<div style={{padding:'10px'}}>
              <div style={{ opacity: 0.9 }}>
                {selectedBuilding.areaSqFt} Sq Ft • {selectedBuilding.floors} Floors
              </div>

              <button
                type="button"
                style={popupButton}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = "0 14px 22px rgba(0,0,0,0.35)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow = "0 10px 18px rgba(0,0,0,0.30)";
                }}
                onClick={() => {setDrawerOpen(true); setHoveredId('')}}
              >
                Open Building Drawer →
              </button>
				</div>
			  <div
			    style={{
			      position: "absolute",
			      bottom: "-10px",
			      left: "50%",
			      width: "0px",
			      height: "0px",
			      transform: "translateX(-50%)",
			      borderLeft: "10px solid transparent",
			      borderRight: "10px solid transparent",
			      borderTop: "10px solid #121821",
			      filter: "drop-shadow(0 6px 10px rgba(0,0,0,0.35))"
			    }}
			  />
            </div>
          )}

        </div>

        {/* Intro swoosh bottom right */}
        <div style={{
          position: "fixed",
          bottom: "0px",
          right: "0px",
          width: "380px",
          height: "240px",
          background: "linear-gradient(135deg, #1f2b44 0%, #121821 100%)",
          color: "#ffffff",
          boxShadow: "0 18px 40px rgba(0,0,0,0.35)",
          borderTopLeftRadius: "140px 120px",
          //borderTopRightRadius: "24px",
          borderBottomLeftRadius: "80px 120px",
        //borderBottomRightRadius: "24px",
          zIndex: 40
        }}>
          <div style={{ padding: "40px 36px 30px 42px", marginLeft: "30px", marginTop: "15px" }}>
            <div style={{ color: "#ffb703", fontSize: "18px", marginBottom: "12px", fontWeight: 700 }}>
              Building Book
            </div>
            <div style={{ fontSize: "22px", fontWeight: 700, lineHeight: "1.3", marginBottom: "12px" }}>
              Explore your portfolio
            </div>
            <div style={{ fontSize: "14px", opacity: 0.85 }}>
              Click any building to view layouts, dashboards, documents and operational insights.
            </div>
          </div>
        </div>

      </div>

      <BuildingDrawer
	    onOpenForge={onOpenForge}
        building={selectedBuilding}
        open={drawerOpen}
        onClose={() => {setDrawerOpen(false); setSelectedBuilding(null)}}
      />

      {drawerOpen && (
        <div
          onClick={() => setDrawerOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.25)",
            zIndex: 55
          }}
        />
      )}
	 <BuildingBookTopRightTools/>
    </>
  );
}
